module.exports = __webpack_public_path__ + "static/media/site2x1200.daa4c049.png";